import type { AdUnit } from '@wix/ambassador-adsense-v1-adsense-adunit/types';

/** @TODO - replace to common utils package */
export const getAdUnitId = (adUnit: AdUnit) =>
  adUnit.reportingDimensionId?.split(':')[1] ?? '';

export const getAdUnitPublisherId = (adUnit: AdUnit) =>
  adUnit.reportingDimensionId?.split(':')[0];

export const getReportingDimensionId = (
  publisherId: string,
  adUnitId: string,
) => `ca-${publisherId}:${adUnitId}`;
